import React, { useContext, useEffect, useState } from 'react';
import "./style.css";
import { mapStyles } from './map';
import mapMarkerHover from "../../assets/img/icons/map_marker_hover.svg";
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import { Context } from '../../context/Products';
import { COOKIE_CONSENT_EVENT, COOKIE_CONSENT_KEY } from '../CookieConsent/CookieConsent';

const containerStyle = {
  width: '100%',
  height: '100%'
};

const center = {
  lat: 42.3154,
  lng: 43.3569,
};

function Maps({ handechanges, id, locations }) {
  const [{ lang }] = useContext(Context);
  const [consent, setConsent] = useState(() => localStorage.getItem(COOKIE_CONSENT_KEY));

  useEffect(() => {
    const handleConsent = (event) => setConsent(event.detail);
    window.addEventListener(COOKIE_CONSENT_EVENT, handleConsent);
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, handleConsent);
  }, []);

  if (consent !== 'all') {
    return (
      <div className="map-consent-placeholder">
        <span className="map-consent-placeholder__icon" aria-hidden="true">✦</span>
        <p>
          {lang === 'ka'
            ? 'Google Maps-ის სანახავად საჭიროა გარე სერვისების ქუქი-ფაილების მიღება.'
            : 'Accept external-service cookies to display Google Maps.'}
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {
            localStorage.setItem(COOKIE_CONSENT_KEY, 'all');
            window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: 'all' }));
          }}
        >
          {lang === 'ka' ? 'რუკის ჩართვა' : 'Enable map'}
        </button>
      </div>
    );
  }

  return <ConsentGrantedMap handechanges={handechanges} id={id} locations={locations} />;
}

function ConsentGrantedMap({ handechanges, id, locations }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyDLKc_wA4t1eOykcIJcs0kd0frcr2sYRvs"
  });

  const open = (hrefLink) => {
    window.open(hrefLink, "_blank");
  }

  const [mark, setMark] = useState(locations);

  const changeImg = (e) => {
    const x = locations?.map((el) => {
      if (el.id === e) {
        return { ...el, icon: mapMarkerHover };
      }
      return el;
    });
    setMark(x);
  }

  useEffect(() => {
    changeImg(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    setMark(locations);
  }, [locations]);

  const markerIcon = (el, index) => ({
    url: el.icon,
    scaledSize: new window.google.maps.Size(48, 53),
    anchor: new window.google.maps.Point(index === 0 ? 65 : index === 1 ? -17 : 24, 53),
  });

  return isLoaded ? (
      <GoogleMap
        disableDefaultUI={true}
        mapContainerStyle={containerStyle}
        center={center}
        zoom={6}
        options={{
          styles: mapStyles,
        }}
      >
        {mark?.map((el, index) => (
          <Marker 
            key={el.id}
            position={el.position}
            onClick={()=> open(el.link)}
            onMouseOut={() => {
              setMark(locations)
              handechanges(null);
            }}
            onMouseOver={() => {
              handechanges(el.id);
              changeImg(el.id);
            }}
            title={el.title}
            icon={markerIcon(el, index)}
          />
        ))}
      </GoogleMap>
  ) : <></>
}

export default Maps;
